import { Site } from '@/models/Site';
import { MutationTree } from 'vuex';
import { SITE_LIST } from './mutation-types';
import { SiteListState, state as initialState } from './state';

export const mutations: MutationTree<SiteListState> = {
    [SITE_LIST.SET_LOADING](state: SiteListState, isLoading: boolean): void {
        state.isLoading = isLoading;
    },
    [SITE_LIST.SET_ERROR](state: SiteListState, error: boolean): void {
        state.error = error;
    },
    [SITE_LIST.ADD_ITEMS](state: SiteListState, items: Site[]): void {
        state.siteList = [...state.siteList, ...items];
    },
    [SITE_LIST.SET_ITEMS](state: SiteListState, items: Site[]): void {
        state.siteList = items;
    },
    [SITE_LIST.SET_SCROLL](state: SiteListState, scroll: number): void {
        state.scroll = scroll;
    },
    [SITE_LIST.SET_PAGE](state: SiteListState, page: number): void {
        state.page = page;
    },
    [SITE_LIST.SET_PAGES](state: SiteListState, pages: number): void {
        state.pages = pages;
    },
    [SITE_LIST.SET_FILTER](state: SiteListState, filter: string): void {
        state.filter = filter;
    },
    [SITE_LIST.RESET](state: SiteListState): void {
        Object.assign(state, initialState());
    },
    [SITE_LIST.SET_SITE_ID](state: SiteListState, siteId: number): void {
        state.siteId = siteId;
    },
    [SITE_LIST.RESET_FILTER](state: SiteListState): void {
        state.filter = '';
    },
};
